// extracted by mini-css-extract-plugin
module.exports = {"scrollToTopBtn":"ScrollToTopButton_scrollToTopBtn__6hro5","isActive":"ScrollToTopButton_isActive__n_iUA"};